<template>
  <Modal content-class="promo-modal">
    <template #activator="{ onClick }">
      <CardPromo button :promo-amount="promo.amount / 100" @click="onClick" />
    </template>
    <template #content="{ close }">
      <div class="promo-modal__inner">
        <div class="promo-modal__icon">
          <img :src="GiftModalBg" alt="Gift icon" />
        </div>
        <div class="promo-modal__content">
          <div v-if="fullName" class="promo-modal__invited">
            <div class="promo-modal__invited_avatar">
              <img
                :src="
                  promoInvited.avatar?.data || promoInvited.avatarPlaceholder
                "
                alt="Avatar"
              />
            </div>
            <div class="promo-modal__invited_user">
              <p>{{ $t('modal.promo.invited') }}</p>
              <p>
                {{ fullName }}
                <template v-if="locale === 'hy'">-ից</template>
              </p>
            </div>
          </div>
          <div
            class="promo-modal__banner"
            :class="[{ 'without-invited-user': !fullName }]"
          >
            <div class="promo-modal__sponsor">
              <svgo-star class="star" />
              <svgo-star class="star" />
              <img :src="promo.sponsor?.avatar?.data" alt="Sponsor avatar" />
            </div>
            <div class="promo-modal__gift">
              <svgo-star class="star" />
              <svgo-star class="star" />
              <img :src="GiftLarge" alt="Gift" />
              <span class="promo-modal__gift_amount">
                <span>$</span>
                {{ promo.amount / 100 }}
              </span>
            </div>
          </div>
          <h3 class="promo-modal__title">
            {{ $t('modal.promo.gift_from', { amount: promo.amount / 100 }) }}
            <br />
            {{ promo.sponsor.name }}
            <template v-if="locale === 'hy'">-ից</template>
          </h3>
          <p class="promo-modal__text">
            «{{ promo.sponsor.name }}»
            <template v-if="locale === 'hy'">-ը</template>
            {{ $t('modal.promo.gift_text', { amount: promo.amount / 100 }) }}
          </p>
          <UiButton
            class="promo-modal__button"
            color="secondary"
            @click="close"
          >
            {{ $t('button.good') }}
          </UiButton>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup>
import GiftModalBg from '~/assets/images/promo/giftModalBg.png';
import GiftLarge from '~/assets/icons/giftLarge.png';

const props = defineProps({
  promo: {
    type: Object,
    default: () => ({}),
  },
  promoInvited: {
    type: Object,
    default: () => ({}),
  },

  locale: {
    type: String,
    default: 'en',
  },
});

const fullName = computed(() => {
  if (!props.promoInvited) return null;
  if (props.promoInvited.firstName && props.promoInvited.lastName) {
    return `${props.promoInvited.firstName} ${props.promoInvited.lastName}`;
  }

  return props.promoInvited.firstName || props.promoInvited.lastName;
});
</script>

<style lang="scss">
@use '@styles/components/pages/project/promoModal.scss' as *;
</style>
